import React, { Component } from 'react';
import logo from "../../assets/svg/logoLumio.svg";
import { Button, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import ListItemLink from "./ListItemLink";
import NavItem from "./NavItem";


export default class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top: 61,
      links: [
        {
          label: "FEATURES",
          to: "/features",
        },
        {
          label: "USE CASE",
          to: "/use-case",
        },
        // {
        //   label: "Pricing",
        //   to: "/pricing",
        // }
      ]
    };

  }

  componentDidMount() {
    this.on([ 'resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load' ], this.recomputeState);
    this.recomputeState();
  }

  componentWillReceiveProps() {
    this.recomputeState();
  }

  componentWillUnmount() {
    this.off([ 'resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load' ], this.recomputeState);
  }

  on(events, callback) {
    events.forEach((evt) => {
      window.addEventListener(evt, callback);
    });
  }

  off(events, callback) {
    events.forEach((evt) => {
      window.removeEventListener(evt, callback);
    });
  }

  recomputeState = () => {
    this.setState({
      top: this.getDistanceFromTop(),
      bottom: this.getDistanceFromBottom()
    });
  };

  getDistanceFromTop() {
    return this.navbarElement.getBoundingClientRect().top;
  }

  getDistanceFromBottom() {
    return this.navbarElement.getBoundingClientRect().bottom;
  }

  renderNavBar(fixed = false) {
    const link = this.state.links.map(
      (link, ids) =>
        <ListItemLink
          key={ids}
          to={link.to}>{link.label}
        </ListItemLink>)
    return (
      <Navbar collapseOnSelect fixedTop={fixed}>
        <div className="col-xs-12 col-lg-10 col-lg-push-1" ref={ref => {
          if (!fixed) this.navbarElement = ref
        }}>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/"> <img src={logo} alt="Lumio.id"/></Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>

            <Button href="https://admin.lumio.id/" target="_blank"
                    className="login hidden-xs pull-right">LOGIN</Button>
            <Nav pullRight>
              {link}
              <NavItem className="visible-xs" href="https://admin.lumio.id"
                       target="_blank">LOGIN</NavItem>
            </Nav>

          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }

  render() {
    return (
      <div>
        {this.renderNavBar()}
        {this.state.top <= 0 && this.renderNavBar(true)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Link/NavBar.js